export default __webpack_public_path__ + "static/media/logo_merchandising.62b69ae1.png";